<template>
  <div id="searchContainer" class="search-container">
    <!--  搜索框  -->
    <div class="search-bar">
      <van-search v-model="search" placeholder="请输入您要办理的事项" @keydown="searchHandle" style="width:100%;border-radius: 20px;"/>
    </div>
    <!--  搜索内容区  -->
    <div class="search-main">
      <div class="search-main-box">
        <div>
          <p v-if="hotWords.length>0" class="title"><span>热词搜索</span></p>
          <div class="hot-world" v-if="hotWords.length>0">
            <span @click="setSearch(item)" v-for="(item,index) in hotWords" :key="index">{{ item }}</span>
          </div>
        </div>
        <p class="title" v-if="limitHighService().length>0"><span>高频办理事项</span><span class="right color999" @click="getLimitHighService"><van-icon class="iconfont" class-prefix="icon" name="ziyuan"></van-icon> 换一批</span></p>
        <ul class="hot-service" v-if="limitHighService().length>0">
            <li v-for="(item,index) in limitHighService()" :key="index" @click.stop.prevent="serviceJump(item)">
              <b>
                <van-icon
                    :class="['iconfont', 'top'+(index+1)]"
                    class-prefix="icon"
                    name="hot"
                    v-if="index < 3"
                ></van-icon>{{ index>2?index+1:''}}</b>
              <span>{{ item.name }}</span>
            </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getHotWord, getHighService } from '@/api/home/index'
import {Toast} from "vant";
import {serviceJump} from "@/utils/serviceUtil";

export default {
  data() {
    return {
      hotWords: [],
      highService: [],
      search: '',
      viewIndex: 0,
      viewSize:6,
      viewTotal:0
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      getHotWord().then(res => {
        if (res.code == 200) {
          this.hotWords = res.data;
        }
      });
      getHighService().then(res => {
        if(res.code && res.code !== 200){
          Toast(res.message)
          return ;
        }
        if (res.data.length && res.data.length > 0){
          this.highService = res.data;
          this.viewTotal = Math.ceil(this.highService.length/this.viewSize);
        }
      })
    },
    searchHandle(e){
      if (e) {
        if(e.code == 'Enter' || e.keyCode == '13') {
          this.$router.push({
            path: '/searchResult',
            query: {
              search: this.search
            }
          })
        }
      } else {
        this.$router.push({
          path: '/searchResult',
          query: {
            search: this.search
          }
        })
      }
    },
    // 热词点击
    setSearch(val) {
      this.search = val;
      this.searchHandle()
    },
    // 获取高频办理事项
    getLimitHighService(){
      this.viewIndex+=1;
      //console.log("viewIndex:",this.viewIndex,"|viewTotal:",this.viewTotal,"|viewIndex*viewSize:",this.viewIndex*this.viewSize,"|viewSize:",this.viewSize)
    },
    limitHighService(){
      let offsetStart = this.viewIndex*this.viewSize
      if(offsetStart>=this.highService.length){
        this.viewIndex = 0;
        offsetStart = 0;
      }
      let offsetEnd = offsetStart+this.viewSize;
      if(offsetEnd>=this.highService.length){
        offsetEnd = this.highService.length;
      }
      return this.highService.slice(offsetStart,offsetEnd);
    },
    serviceJump
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/theme/theme";
.search-bar {
  width: 100%;
  height: 44px;
  padding: 8px 15px;
  box-sizing: border-box;
  display: -webkit-flex;/* Safari */
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index:10001;
  background: #fff;
  color: $c333;
  .go-back{
    width: 28px;
    height: 28px;
    position: relative;
    .iconfont {
      position: absolute;
      left: 0;
      top: 4px;
      font-size: 20px;
      transform: rotate(180deg);
    }
  }
  .search-box {
    height: 28px;
    line-height: 28px;
    padding: 0 15px 0 35px;
    background: #F7F7F7;
    border: 1px solid #FFFFFF;
    border-radius: 14px;
    flex: 1;
    position: relative;
    @extend .font13;
    .search-icon{
      position: absolute;
      top:0;
      left: 15px;
    }
    form{
      width: 100%;
      background: transparent;
      height: 28px;
      line-height: 28px;
      padding: 0;
      input {
        float: left;
        width: 100%;
        height: 28px;
        line-height: 28px;
        background: transparent;
        @extend .font13;
        &::-webkit-search-cancel-button{
          -webkit-appearance: none;
        }
      }
    }
  }
  .assistant{
    height: 28px;
    line-height: 28px;
    margin-left: 15px;
    @extend .font16;
  }
}
.search-main {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 15px;
  padding-top: 50px;
  overflow-y: auto;
  background: #fff;
  z-index: 100;
  &.grayBg{
    background: #f7f7f7;
  }
  .title{
    height: 45px;
    line-height: 45px;
    @extend .font16;
    color: $c333;
    display: flex;
    justify-content: space-between;
    span.right, .iconfont{
      @extend .font13;
    }
  }
  .hot-world{
    display: flex;
    flex-wrap: wrap;
    span{
      display: inline-flex;
      height: 32px;
      line-height: 32px;
      border-radius: 16px;
      padding: 0 15px;
      margin-right: 10px;
      margin-bottom: 10px;
      color: $c999;
      background: #f7f7f7;
      flex-shrink: 0;
      @extend .font13;
    }
  }
  .hot-service{
    li{
      height: 40px;
      line-height: 40px;
      padding:0 10px;
      padding-left: 37px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      position: relative;
      @extend .font14;
      b{
        display: inline-block;
        width: 17px;
        height: 40px;
        color: #999;
        text-align: center;
        margin-right: 10px;
        font-weight: 500;
        position: absolute;
        top: 0;
        left: 10px;
        .top1 {
          color: #f26100;
        }
        .top2 {
          color: #fdab4d;
        }
        .top3 {
          color: #dacaaa;
        }
      }
    }
  }
}
.empty{
  margin-top: 100px;
}
</style>
<style lang="scss">
.search-bar input::placeholder{
  color: #666666!important;
}
</style>
